<template>
  <div class="login" v-loading="appleLoginLoading">
    <AppHeader v-if="$isElectron && isMac" :showRight="false" />
    <div
      class="login__container"
      :style="{
        marginTop: isMobile ? '50px' : '100px',
      }"
    >
      <div class="login__container__header">
        <div class="login__container__header__icon">
          <svg-icon iconClass="logoShape" className="login__container__header__icon--logo"></svg-icon>
          <svg-icon iconClass="logoText" className="login__container__header__icon--text"></svg-icon>
        </div>
        <div class="login__container__header__text">
          {{ $t('login.account') }}
        </div>
      </div>
      <div class="login__container__form">
        <el-input v-model="email" :placeholder="$t('login.email')" v-on:keyup.enter.native="onLogin"></el-input>
        <el-input
          v-model="password"
          :placeholder="$t('login.password')"
          show-password
          v-on:keyup.enter.native="onLogin"
          @blur="onBlur"
          ref="password"
          class="password"
        ></el-input>
        <el-checkbox v-model="privacyChecked" v-if="is_quickapp">{{ $t('login.agree') }}</el-checkbox
        ><el-link
          v-if="is_quickapp"
          type="primary"
          :underline="false"
          @click="redirectToPrivacy"
          style="position: relative; top: -1px"
          >{{ $t('login.privacy') }}</el-link
        >
        <el-button
          type="primary"
          @click="onLoginWithBlur"
          v-baidu-event-tracking="{ feature: '登录页操作', action: '登录按钮' }"
          :loading="loading"
          >{{ $t('login.login') }}</el-button
        >
        <div class="login__container__form__action">
          <el-link
            v-baidu-event-tracking="{ feature: '登录页操作', action: '忘记密码' }"
            :underline="false"
            @click="redirectToForgetpassword"
            >{{ $t('login.forget_password') }}</el-link
          >
          <el-link
            :underline="false"
            v-baidu-event-tracking="{ feature: '登录页操作', action: '立即注册' }"
            @click="redirectToSignUp"
            >{{ $t('login.sign_up_now') }}</el-link
          >
        </div>
        <div class="login__container__form__wx" @click="clickWxLogin" v-if="showWxLogin">
          <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.49384 0.230469C3.82364 0.230469 0 3.40507 0 7.45447C0 9.78248 1.26984 11.7014 3.40036 13.1828L2.5538 15.7367L5.51677 14.241C6.57496 14.4527 7.43563 14.6643 8.49384 14.6643C8.76192 14.6643 9.02999 14.6502 9.28396 14.6362C9.11465 14.0717 9.01588 13.4791 9.01588 12.8583C9.01588 9.14757 12.2046 6.14229 16.2398 6.14229C16.5221 6.14229 16.7901 6.1564 17.0582 6.19873C16.3245 2.77015 12.6702 0.230469 8.49384 0.230469ZM5.64375 5.95887C5.06526 5.95887 4.59965 5.49326 4.59965 4.91477C4.59965 4.33629 5.06526 3.87068 5.64375 3.87068C6.22223 3.87068 6.68784 4.33629 6.68784 4.91477C6.68784 5.49326 6.22223 5.95887 5.64375 5.95887ZM11.612 5.95887C11.0336 5.95887 10.5679 5.49326 10.5679 4.91477C10.5679 4.33629 11.0336 3.87068 11.612 3.87068C12.1905 3.87068 12.6561 4.33629 12.6561 4.91477C12.6561 5.49326 12.1905 5.95887 11.612 5.95887ZM24 12.7596C24 9.35921 20.5997 6.59379 16.7901 6.59379C12.7548 6.59379 9.56615 9.35921 9.56615 12.7596C9.56615 16.1599 12.7548 18.9254 16.7901 18.9254C17.6367 18.9254 18.4833 18.7138 19.3439 18.5021L21.672 19.7719L21.0371 17.6556C22.7302 16.3716 24 14.6785 24 12.7596ZM14.5467 11.6873C14.0811 11.6873 13.7002 11.3063 13.7002 10.8407C13.7002 10.3751 14.0811 9.99411 14.5467 9.99411C15.0123 9.99411 15.3933 10.3751 15.3933 10.8407C15.3933 11.3063 15.0123 11.6873 14.5467 11.6873ZM19.1605 11.6873C18.6949 11.6873 18.314 11.3063 18.314 10.8407C18.314 10.3751 18.6949 9.99411 19.1605 9.99411C19.6261 9.99411 20.0071 10.3751 20.0071 10.8407C20.0071 11.3063 19.6402 11.6873 19.1605 11.6873Z"
              fill="#07C160"
            />
          </svg>
          <span>{{ $t('login.login_with_wechat') }}</span>
        </div>
        <AppleLogin v-if="showAppleLogin && isMAS" />
      </div>
    </div>
    <BindWxDialog @close="handleBindWxDialogClose" />
    <BindAccountDialog />
  </div>
</template>

<script>
import DBUtil from '../utils/DBUtil.js'
import BindWxDialog from '../components/BindWxDialog.vue'
import BindAccountDialog from '../components/BindAccountDialog.vue'
import AppleLogin from '@/components/AppleLogin.vue'
import { getOsType } from '@utils/utils.js'
import AppHeader from '@/components/Desktop/AppHeader.vue'
import api from 'api'
export default {
  components: {
    BindWxDialog,
    BindAccountDialog,
    AppleLogin,
    AppHeader,
  },
  data() {
    return {
      email: '',
      password: '',
      privacyChecked: false,
      is_quickapp: false,
      isZh: true,
      loading: false,
      in_wechat: false,
      showWxLogin: false,
      isMAS: window.isMAS != undefined && window.isMAS,
      showAppleLogin: false,
      wxLoginTimer: null,
      isMac: getOsType() == 'mac',
    }
  },
  computed: {
    appleLoginLoading() {
      return this.$store.getters['appleLogin/loading']
    },
    wxLoginInfo() {
      return this.$store.getters['wxLogin/info']
    },
    isMobile() {
      return this.$isMobile() || document.body.clientWidth < 640
    },
  },
  methods: {
    handleBindWxDialogClose() {
      clearInterval(this.wxLoginTimer)
    },
    checkWxLogin() {
      if (!this.wxLoginInfo) {
        return
      }
      const { uniqueKey } = this.wxLoginInfo
      api.call('POST', '/wechat_account/login_by_oa_qrcode', { uniqueKey }, async (res) => {
        const {
          data: { code, data },
        } = res
        if (code == 0) {
          this.$store.dispatch('wxLogin/hide')
          this.$store.dispatch('wxLogin/toggleLoading', false)
          clearInterval(this.wxLoginTimer)
          if (data.user) {
            this.$store.dispatch('updateUserInfo', data.user)
            await this.clearDBAndRedirect.call(this)
          } else {
            // 没有绑定账号
            this.$store.dispatch('wxLogin/updateBindAccountDialog', true)
            this.$store.dispatch('wxLogin/updateWechatAccount', data)
          }
        }
      })
    },
    clickWxLogin() {
      if (this.in_wechat) {
        this.loginInWechat()
        return
      }

      this.$store.dispatch('wxLogin/get')
      this.wxLoginTimer = setInterval(() => {
        this.checkWxLogin()
      }, 1000)
    },
    // fix ios flomo app auto fill password
    onLoginWithBlur() {
      this.$refs.password.blur()
      setTimeout(() => {
        this.onLogin()
      }, 300)
    },
    onLogin() {
      if (!this.email) {
        this.$message.error(this.$t('login.message.fill_email'))
        return
      }
      if (!this.password) {
        const password = document.querySelector('.password input').value
        if (!password) {
          this.$message.error(this.$t('login.message.fill_password'))
          return
        } else {
          this.password = password
        }
      }

      if (this.is_quickapp && !this.privacyChecked) {
        this.$message.error(this.$t('login.message.check_privacy'))
        return
      }

      this.loading = true

      this.$api.call(
        'POST',
        '/user/login_by_email',
        {
          email: this.email.trim(),
          password: this.password.trim(),
          wechat_union_id: '',
          wechat_oa_open_id: '',
        },
        async (response) => {
          if (!response.data) {
            this.loading = false
            return
          }
          await this.handleLoginResponse.call(this, response)
          this.loading = false
        },
      )
    },

    async handleLoginResponse(response) {
      if (response.data.code === '-101') {
        this.$store.dispatch('wxLogin/updateBindOtherAccountDialog', true)
      } else if (response.data.code === 0) {
        if (response.data.data.access_token) {
          this.$store.dispatch('updateUserInfo', response.data.data)
          await this.clearDBAndRedirect.call(this)
        } else {
          showError.call(this, response.data.message)
        }
      }
    },
    async clearDBAndRedirect() {
      await DBUtil.clearDB()
      const redirectPathAfterLogin = localStorage.getItem('redirect_path_after_login')
      if (redirectPathAfterLogin) {
        localStorage.removeItem('redirect_path_after_login')
        this.$router.replace(redirectPathAfterLogin)
      } else {
        this.$router.replace({ name: 'mine' })
      }
    },
    showError(message) {
      this.$message.error(message)
    },
    redirectToForgetpassword() {
      this.$router.push({
        name: 'forget',
      })
    },
    redirectToRegister() {
      this.$router.push({
        name: 'register',
      })
    },
    redirectToHome() {
      window.location.replace('https://flomoapp.com')
    },
    redirectToPrivacy() {
      window.open('/privacy/')
    },

    redirectToSignUp() {
      // window.location.replace("/register2/");
      this.$router.push({
        name: 'register',
      })
    },
    loginInWechat() {
      let { code } = this.$route.query
      if (process.env.NODE_ENV !== 'production') {
        // fake login
        code = 'test'
      }
      if (!code) {
        // 判断是不是 stage 环境
        const { host } = window.location
        let redirect_uri = 'https://v.flomoapp.com/login'
        if (host === 'stage.flomoapp.com' || host === 'localhost:8080') {
          redirect_uri = 'https://stage.flomoapp.com/login'
        }

        redirect_uri = encodeURIComponent(redirect_uri)
        //https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx4fddc39d1902946d&redirect_uri=https%3A%2F%2Fv.flomoapp.com%2Flogin&response_type=code&scope=snsapi_userinfo#wechat_redirect
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx4fddc39d1902946d&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
        return
      }
      api.call('POST', '/wechat_account/login_by_code/', { code }, async (res) => {
        if (res.data) {
          const {
            data: { code, data },
          } = res
          if (code == 0) {
            if (data.user) {
              this.$store.dispatch('updateUserInfo', data.user)
              await this.clearDBAndRedirect.call(this)
            } else {
              // 没有绑定账号
              this.$store.dispatch('wxLogin/updateBindAccountDialog', true)
              this.$store.dispatch('wxLogin/updateWechatAccount', data)
            }
          }
        }
      })
    },
    onBlur(e) {
      this.password = e.target.value
    },
    handleCloseWindow() {
      this.$store.dispatch('appleLogin/setLoading', false)
    },
    async handleAppleLogin(event, arg) {
      console.log('ipc apple-account-login-by-identity-token-web', arg)
      const data = JSON.parse(arg.data)
      console.log('ipc apple-account-login-by-identity-token-web', data)
      this.$store.dispatch('appleLogin/setAccount', data)
      const {
        code,
        data: { user },
      } = data
      if (code === 0 && user) {
        setTimeout(() => {
          this.$router.replace({
            name: 'mine',
          })
        }, 300)
      }
    },
    handleAppleLoginEvent() {
      window.ipcRenderer.on('apple-account-login-by-identity-token-web', this.handleAppleLogin)
      window.ipcRenderer.on('close-new-window', this.handleCloseWindow)
    },
    handleMediaQueryChange(mq) {
      const themeColor = document.querySelector('[name=theme-color]')
      if (this.$store.state.theme == 'auto') {
        if (mq.matches) {
          this.handleDark()
        } else {
          document.body.removeAttribute('class', 'dark_mode')
          document.documentElement.setAttribute('data-theme', 'light')
          if (themeColor == undefined) {
            return
          }
          themeColor.setAttribute('content', '#fafafa')
        }
      }
    },
    handleDark() {
      const themeColor = document.querySelector('[name=theme-color]')
      document.getElementsByTagName('body')[0].className = 'dark_mode'
      document.documentElement.setAttribute('data-theme', 'dark')
      if (themeColor == undefined) {
        return
      }
      themeColor.setAttribute('content', '#000000')
    },
  },
  created() {
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    darkModeMediaQuery.addListener(this.handleMediaQueryChange)
    darkModeMediaQuery.matches && this.handleDark()
    if (getOsType() == 'mac' && this.$isElectron) {
      this.showAppleLogin = true
      this.handleAppleLoginEvent()
    }

    this.isZh = window.navigator.language.toLowerCase().slice(0, 2) === 'zh'
    if (this.$store.state.me) {
      // 已登录
      let redirect_path_after_login = localStorage.getItem('redirect_path_after_login')
      if (redirect_path_after_login) {
        localStorage.removeItem('redirect_path_after_login')
        this.$router.replace(redirect_path_after_login)
      } else {
        this.$router.replace({ name: 'mine' })
      }
    } else {
      // 未登录
      let in_wechat = /MicroMessenger/i.test(window.navigator.userAgent)
      this.in_wechat = in_wechat
      if (in_wechat) {
        this.showWxLogin = true
        this.loginInWechat()
      } else if (!this.$isMobile()) {
        this.showWxLogin = true
      }
    }
  },
  beforeDestroy() {
    // 移除事件监听器
    if (this.$isElectron) {
      window.ipcRenderer.removeListener('apple-account-login-by-identity-token-web', this.handleAppleLogin)
      window.ipcRenderer.removeListener('close-new-window', this.handleCloseWindow)
    }
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    darkModeMediaQuery.removeEventListener('change', this.handleMediaQueryChange)
  },
}
</script>
<style lang="scss" scoped>
.login {
  &__container {
    width: 400px;
    margin: 100px auto;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 45px;
      &__icon {
        &--logo {
          width: 31.6px !important;
          height: 24px !important;
          color: var(--bgGreen) !important;
        }
        &--text {
          width: 79.5px !important;
          height: 24px !important;
          margin-left: 5px;
          color: var(--logoColor) !important;
        }
      }
      &__text {
        font-size: 20px;
        font-weight: 600;
        color: var(--textBlack);
      }
    }
    &__form {
      &__action {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
      }
      &__wx {
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--loginWxBg);
        border: 1px solid var(--loginBtnBorder);
        box-sizing: border-box;
        border-radius: 6px;
        padding: 15px 20px;
        color: #07c160;
        cursor: pointer;
        &:hover {
          background: var(--hoverBg);
        }
        svg {
          width: 24px;
          height: 24px;
        }
        span {
          margin-left: 10px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.login {
  &__container {
    &__form {
      .el-input {
        margin-bottom: 15px;
        .el-input__inner {
          height: 56px;
          line-height: 56px;
          border-radius: 6px;
          border: 1px solid rgba(239, 239, 239, 1);
          background: var(--loginInputBg);
          color: var(--memoContentColor);
        }
      }
      .el-button {
        width: 100%;
        background: var(--bgGreen);
        border: 1px solid var(--loginBtnBorder);
        box-sizing: border-box;
        border-radius: 6px;
        padding: 20px 20px;
        margin-bottom: 30px;
        color: var(--memberPlanColor);
        &:hover {
          background: var(--yearPlanHoverBg);
          border: 1px solid var(--loginBtnBorder);
        }
      }
      .el-link.el-link--default {
        color: var(--tagColor);
        font-weight: unset;
      }
    }
  }
}
</style>
<style scoped lang="scss">
@media screen and (max-width: 600px) {
  .login {
    &__container {
      width: 350px;
    }
  }
}
</style>
<style>
body.dark_mode .login__container__form .el-input__inner {
  border: 1px solid var(--loginBtnBorder) !important;
}
body.dark_mode .el-button--primary:hover {
  background: var(--bgGreen) !important;
  border: 1px solid var(--loginBtnBorder) !important;
}
</style>
